import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import {
  useLocation,
  useNavigate,
} from "react-router-dom";

import {


  addDoc,
  collection,
  getDocs,
  limit,
  onSnapshot,
  query,
  serverTimestamp,
  where,
} from "firebase/firestore";

import { db } from "../firebase";

import "./ConfirmOrder.css";
import websocket from "../services/websocket";
import ForexBottomNav from "../Components/ForexBottomNav";
import ForexHeader from "./ForexHeader";

const SYMBOL_CONFIG = {
  // FOREX
  AUDCAD: { contractSize: 100000, leverage: 1000 },
  AUDCHF: { contractSize: 100000, leverage: 1000 },
  AUDJPY: { contractSize: 100000, leverage: 1000 },
  AUDNZD: { contractSize: 100000, leverage: 1000 },
  AUDUSD: { contractSize: 100000, leverage: 1000 },

  EURAUD: { contractSize: 100000, leverage: 1000 },
  EURCAD: { contractSize: 100000, leverage: 1000 },
  EURCHF: { contractSize: 100000, leverage: 1000 },
  EURGBP: { contractSize: 100000, leverage: 1000 },
  EURJPY: { contractSize: 100000, leverage: 1000 },
  EURNZD: { contractSize: 100000, leverage: 1000 },
  EURUSD: { contractSize: 100000, leverage: 1000 },

  GBPAUD: { contractSize: 100000, leverage: 1000 },
  GBPCAD: { contractSize: 100000, leverage: 1000 },
  GBPCHF: { contractSize: 100000, leverage: 1000 },
  GBPJPY: { contractSize: 100000, leverage: 1000 },
  GBPNZD: { contractSize: 100000, leverage: 1000 },
  GBPUSD: { contractSize: 100000, leverage: 1000 },

  NZDJPY: { contractSize: 100000, leverage: 1000 },
  NZDUSD: { contractSize: 100000, leverage: 1000 },

  USDCAD: { contractSize: 100000, leverage: 1000 },
  USDCHF: { contractSize: 100000, leverage: 1000 },
  USDJPY: { contractSize: 100000, leverage: 1000 },
  USDMXN: { contractSize: 100000, leverage: 1000 },
  USDPLN: { contractSize: 100000, leverage: 1000 },

  // WLD (weka sawa na specification ya broker wako)
  WLDAUD: { contractSize: 1, leverage: 1000 },
  WLDEUR: { contractSize: 1, leverage: 1000 },
  WLDGBP: { contractSize: 1, leverage: 1000 },
  WLDUSD: { contractSize: 1, leverage: 1000 },

  // METALS
  XAUUSD: { contractSize: 500, leverage: 1000 },   // Gold
  XAGUSD: { contractSize: 5000, leverage: 1000 },  // Silver
  XPDUSD: { contractSize: 100, leverage: 1000 },   // Palladium
  XPTUSD: { contractSize: 100, leverage: 1000 },   // Platinum
};


const ConfirmOrder = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // =====================================================
  // DATA FROM TRADING VIEW
  // =====================================================

  const {
    symbol = "EURUSD",
    side = "buy",
    price = 0,
  } = location.state || {};

  const normalizedSide =
    String(side).toLowerCase();

  const isBuy =
    normalizedSide === "buy";





    

  // =====================================================
  // SYMBOL / CURRENCIES
  // =====================================================

  const cleanSymbol = useMemo(() => {
    return String(symbol)
      .replace(/[^A-Za-z]/g, "")
      .toUpperCase();
  }, [symbol]);

  const baseCurrency = useMemo(() => {
    return (
      cleanSymbol.slice(0, 3) ||
      "EUR"
    );
  }, [cleanSymbol]);

  const quoteCurrency = useMemo(() => {
    return (
      cleanSymbol.slice(3, 6) ||
      "USD"
    );
  }, [cleanSymbol]);


    const symbolConfig =
      SYMBOL_CONFIG[cleanSymbol] || {
        contractSize: 100000,
        leverage: 1000,
      };
    
    const contractSize =
      symbolConfig.contractSize;
    
    const leverage =
      symbolConfig.leverage;


  // =====================================================
  // LIVE MARKET PRICE
  // =====================================================

  const [
    currentPrice,
    setCurrentPrice,
  ] = useState(() => {
    const value = Number(price);

    return Number.isFinite(value)
      ? value
      : 0;
  });
  const [baseUsdRate, setBaseUsdRate] = useState(null);
  // =====================================================
  // ORDER PROCESSING
  // =====================================================

  const [
    orderStatus,
    setOrderStatus,
  ] = useState("idle");

  // idle | processing | success | error

  const [
    orderError,
    setOrderError,
  ] = useState("");

  const [
    placedOrder,
    setPlacedOrder,
  ] = useState(null);

  // =====================================================
  // ORDER SIZE
  // =====================================================
  

  const [
    sizeMode,
    setSizeMode,
  ] = useState("amount");

  const [
    lots,
    setLots,
  ] = useState(0.04);

  const [
    amountInput,
    setAmountInput,
  ] = useState("");

  const [
    lotsInput,
    setLotsInput,
  ] = useState("");

  const [
    unitsInput,
    setUnitsInput,
  ] = useState("");

  // =====================================================
  // PENDING ORDER
  // =====================================================

  const [
    pendingEnabled,
    setPendingEnabled,
  ] = useState(false);

  const [
    pendingPrice,
    setPendingPrice,
  ] = useState(() => {
    const value = Number(price);

    return Number.isFinite(value) &&
      value > 0
      ? value.toFixed(5)
      : "";
  });

  // =====================================================
  // EXPIRY
  // =====================================================

  const [
    expiryEnabled,
    setExpiryEnabled,
  ] = useState(false);




  const [expiryDate, setExpiryDate] = useState("");
  const [expiryTime, setExpiryTime] = useState("");



  

  const dateInputRef =
    useRef(null);

  const timeInputRef =
    useRef(null);

  // =====================================================
  // STOP LOSS
  // =====================================================

  const [
    stopLossEnabled,
    setStopLossEnabled,
  ] = useState(false);

  const [
    stopLoss,
    setStopLoss,
  ] = useState(() => {
    const value = Number(price);

    return Number.isFinite(value) &&
      value > 0
      ? value.toFixed(5)
      : "";
  });

  // =====================================================
  // TAKE PROFIT
  // =====================================================

  const [
    takeProfitEnabled,
    setTakeProfitEnabled,
  ] = useState(false);

  const [
    takeProfit,
    setTakeProfit,
  ] = useState(() => {
    const value = Number(price);

    return Number.isFinite(value) &&
      value > 0
      ? value.toFixed(5)
      : "";
  });

  // =====================================================
  // FIRESTORE BALANCE
  // =====================================================

  const [
    marginAvailable,
    setMarginAvailable,
  ] = useState(0);

  const [
    balanceLoading,
    setBalanceLoading,
  ] = useState(true);

  const [
    balanceError,
    setBalanceError,
  ] = useState("");

  // =====================================================
  // LIVE PRICE WEBSOCKET
  // =====================================================

  useEffect(() => {
    if (!cleanSymbol) {
      return undefined;
    }

    const apiSymbol =
      `frx${cleanSymbol}`;

    websocket.connect();

    const unsubscribe =
      websocket.onTick(
        (data) => {
          if (data?.error) {
            console.error(
              "ConfirmOrder live price error:",
              data.error.code,
              data.error.message
            );

            return;
          }

          // ===============================
          // TICK
          // ===============================

          if (data?.tick) {
            const tickSymbol =
              String(
                data.tick.symbol ||
                data.tick
                  .underlying_symbol ||
                ""
              );

            if (
              tickSymbol !==
              apiSymbol
            ) {
              return;
            }

            const livePrice =
              Number(
                data.tick.quote
              );

            if (
              !Number.isFinite(
                livePrice
              ) ||
              livePrice <= 0
            ) {
              return;
            }

            setCurrentPrice(
              livePrice
            );

            return;
          }

          // ===============================
          // OHLC
          // ===============================

          if (data?.ohlc) {
            const ohlcSymbol =
              String(
                data.ohlc.symbol ||
                data.ohlc
                  .underlying_symbol ||
                ""
              );

            if (
              ohlcSymbol !==
              apiSymbol
            ) {
              return;
            }

            const livePrice =
              Number(
                data.ohlc.close
              );

            if (
              !Number.isFinite(
                livePrice
              ) ||
              livePrice <= 0
            ) {
              return;
            }

            setCurrentPrice(
              livePrice
            );
          }
        }
      );

    websocket.history(
      apiSymbol,
      30
    );

    return () => {
      if (
        typeof unsubscribe ===
        "function"
      ) {
        unsubscribe();
      }
    };
  }, [cleanSymbol]);




// LIVE USD PAIR RATE FOR CROSS-PAIR MARGIN
useEffect(() => {
  if (!baseCurrency || baseCurrency === "USD") {
    setBaseUsdRate(null);
    return undefined;
  }

  const usdSymbol = `frx${baseCurrency}USD`;

  websocket.connect();

  const unsubscribe = websocket.onTick((data) => {
    if (data?.error || !data?.tick) return;

    const tickSymbol = String(
      data.tick.symbol ||
      data.tick.underlying_symbol ||
      ""
    );

    if (tickSymbol !== usdSymbol) return;

    const rate = Number(data.tick.quote);

    if (Number.isFinite(rate) && rate > 0) {
      setBaseUsdRate(rate);
    }
  });

  websocket.history(usdSymbol, 30);

  return () => {
    if (typeof unsubscribe === "function") {
      unsubscribe();
    }
  };
}, [baseCurrency]);








 // =====================================================
// CALCULATED VALUES
// =====================================================

// Idadi ya units katika position
const units = useMemo(() => {
return Math.round(
  Number(lots || 0) * contractSize
);
}, [lots, contractSize]);

// Thamani ya position katika sarafu ya quote.
// Hii si margin inayohitajika.
const amount = useMemo(() => {
if (currentPrice <= 0) return 0;

return (
  Number(lots || 0) *
  contractSize *
  currentPrice
);
}, [lots, contractSize, currentPrice]);

// Margin estimate.
// Hii inafaa moja kwa moja kwa baadhi ya pairs tu.
// Cross pairs zinahitaji currency conversion.

const USD_TO_USDT = 1;

const marginRequired = useMemo(() => {
const safeLots = Number(lots);
const safePrice = Number(currentPrice);
const safeLeverage = Number(leverage);
const safeContractSize = Number(contractSize);

if (
  !Number.isFinite(safeLots) || safeLots <= 0 ||
  !Number.isFinite(safePrice) || safePrice <= 0 ||
  !Number.isFinite(safeLeverage) || safeLeverage <= 0 ||
  !Number.isFinite(safeContractSize) || safeContractSize <= 0
) {
  return null;
}

const units = safeLots * safeContractSize;

// USD ndiyo sarafu ya kwanza
if (baseCurrency === "USD") {
  return units / safeLeverage;
}

// USD ndiyo sarafu ya pili
if (quoteCurrency === "USD") {
  return (units * safePrice) / safeLeverage;
}

// Cross-pairs: tumia USD pair ya base currency.
const safeBaseUsdRate = Number(baseUsdRate);

if (
  Number.isFinite(safeBaseUsdRate) &&
  safeBaseUsdRate > 0
) {
  return (units * safeBaseUsdRate) / safeLeverage;
}

return null;
}, [
lots,
currentPrice,
leverage,
contractSize,
baseCurrency,
quoteCurrency,
baseUsdRate,
]);









const marginCalculationValid =
Number.isFinite(marginRequired) &&
marginRequired > 0;



const amountInputRef = useRef(null);

useEffect(() => {
  if (
    document.activeElement === amountInputRef.current
  ) {
    return;
  }

  if (
    Number.isFinite(marginRequired) &&
    marginRequired > 0
  ) {
    setAmountInput(marginRequired.toFixed(2));
  }
}, [marginRequired]);



const calculateMarginForLots = (lotsValue) => {
  const safeLots = Number(lotsValue);
  const safePrice = Number(currentPrice);
  const safeLeverage = Number(leverage);
  const safeContractSize = Number(contractSize);

  if (
    !Number.isFinite(safeLots) ||
    safeLots <= 0 ||
    !Number.isFinite(safePrice) ||
    safePrice <= 0 ||
    !Number.isFinite(safeLeverage) ||
    safeLeverage <= 0 ||
    !Number.isFinite(safeContractSize) ||
    safeContractSize <= 0
  ) {
    return null;
  }

  const unitsValue = safeLots * safeContractSize;

  if (baseCurrency === "USD") {
    return unitsValue / safeLeverage;
  }

  if (quoteCurrency === "USD") {
    return (unitsValue * safePrice) / safeLeverage;
  }

  const rate = Number(baseUsdRate);

  if (Number.isFinite(rate) && rate > 0) {
    return (unitsValue * rate) / safeLeverage;
  }

  return null;
};

const marginDisplay = marginCalculationValid
? `$ ${marginRequired.toFixed(2)}`
: `Margin haijahesabiwa kwa ${cleanSymbol}`;
  // =====================================================
  // INITIAL SIZE
  // =====================================================

  useEffect(() => {
    setAmountInput(
      marginRequired != null
        ? marginRequired.toFixed(2)
        : ""
    );
  
    setLotsInput(Number(lots).toFixed(2));
    setUnitsInput(String(units));
  
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // =====================================================
  // GET USER BALANCE
  // =====================================================

 
useEffect(() => {
  const username = localStorage.getItem("username")?.trim();

  if (!username) {
    setMarginAvailable(0);
    setBalanceError("Username not found");
    setBalanceLoading(false);
    return undefined;
  }

  setBalanceLoading(true);
  setBalanceError("");

  let currentBalance = 0;
  let orders = [];
  let gotUser = false;
  let gotOrders = false;

  const updateFreeMargin = () => {
    if (!gotUser || !gotOrders) return;

    const usedMargin = orders.reduce((total, order) => {
      const status = String(order.status || "").toLowerCase();

      const closed =
        order.closed === true ||
        ["closed", "cancelled", "canceled", "rejected", "expired"]
          .includes(status);

      const active =
        !closed &&
        (status === "open" ||
          status === "pending" ||
          order.isPending === true);

      if (!active) return total;

      const margin = Number(
        order.marginRequired ?? order.margin ?? 0
      );

      return total + (
        Number.isFinite(margin) && margin > 0 ? margin : 0
      );
    }, 0);

    // Free margin = balance - margin inayotumika
    setMarginAvailable(
      Math.max(0, currentBalance - usedMargin)
    );

    setBalanceError("");
    setBalanceLoading(false);
  };

  const userQuery = query(
    collection(db, "users"),
    where("username", "==", username),
    limit(1)
  );

  const ordersQuery = query(
    collection(db, "Forex"),
    where("username", "==", username)
  );

  const unsubscribeUser = onSnapshot(
    userQuery,
    (snapshot) => {
      if (snapshot.empty) {
        setMarginAvailable(0);
        setBalanceError("User not found");
        setBalanceLoading(false);
        return;
      }

      const userData = snapshot.docs[0].data();
      const balance = Number(userData.usdtBalanceOther ?? 0);

      if (!Number.isFinite(balance) || balance < 0) {
        setBalanceError("Invalid balance");
        setBalanceLoading(false);
        return;
      }

      currentBalance = balance;
      gotUser = true;
      updateFreeMargin();
    },
    (error) => {
      console.error("Live balance error:", error);
      setBalanceError("Failed to load balance");
      setBalanceLoading(false);
    }
  );

  const unsubscribeOrders = onSnapshot(
    ordersQuery,
    (snapshot) => {
      orders = snapshot.docs.map((doc) => doc.data());
      gotOrders = true;
      updateFreeMargin();
    },
    (error) => {
      console.error("Live orders error:", error);
      setBalanceError("Failed to load orders");
      setBalanceLoading(false);
    }
  );

  return () => {
    unsubscribeUser();
    unsubscribeOrders();
  };
}, []);

  // =====================================================
  // UPDATE DEFAULT PRICES
  // =====================================================

  useEffect(() => {
    if (
      !Number.isFinite(
        currentPrice
      ) ||
      currentPrice <= 0
    ) {
      return;
    }

    const formatted =
      currentPrice.toFixed(5);

    if (!pendingEnabled) {
      setPendingPrice(
        formatted
      );
    }

    if (!stopLossEnabled) {
      setStopLoss(
        formatted
      );
    }

    if (!takeProfitEnabled) {
      setTakeProfit(
        formatted
      );
    }
  }, [
    currentPrice,
    pendingEnabled,
    stopLossEnabled,
    takeProfitEnabled,
  ]);

  // =====================================================
  // DECIMAL VALIDATION
  // =====================================================

  const isValidDecimalText = (
    value
  ) => {
    return /^\d*\.?\d*$/.test(
      value
    );
  };

  // =====================================================
  // AMOUNT
  // =====================================================

  const handleAmountChange = (value) => {
    if (!isValidDecimalText(value)) return;
  
    setAmountInput(value);
  
    if (
      value === "" ||
      value === "." ||
      value.endsWith(".")
    ) {
      return;
    }
  
    const parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed < 0) return;
  
    const safePrice = Number(currentPrice);
    const safeLeverage = Number(leverage);
    const safeContractSize = Number(contractSize);
  
    if (
      safePrice <= 0 ||
      safeLeverage <= 0 ||
      safeContractSize <= 0
    ) {
      return;
    }
  
    let newLots;
  
    if (baseCurrency === "USD") {
      newLots = (parsed * safeLeverage) / safeContractSize;
    } else if (quoteCurrency === "USD") {
      newLots =
        (parsed * safeLeverage) /
        (safeContractSize * safePrice);
    } else {
      const rate = Number(baseUsdRate);
  
      if (!Number.isFinite(rate) || rate <= 0) return;
  
      newLots =
        (parsed * safeLeverage) /
        (safeContractSize * rate);
    }
  
    newLots = Math.max(0, newLots);
  
    setLots(newLots);
    setLotsInput(newLots.toFixed(4));
    setUnitsInput(
      String(Math.round(newLots * contractSize))
    );
  };
  // =====================================================
  // LOTS
  // =====================================================

  
  const handleLotsChange = (value) => {
    if (!isValidDecimalText(value)) return;
  
    setLotsInput(value);
  
    if (
      value === "" ||
      value === "." ||
      value.endsWith(".")
    ) {
      return;
    }
  
    const parsed = Number(value);
    if (!Number.isFinite(parsed)) return;
  
    const safeLots = Math.max(0, parsed);
  
    setLots(safeLots);
  
    const required = calculateMarginForLots(safeLots);
  
    setAmountInput(
      required != null ? required.toFixed(2) : ""
    );
  
    setUnitsInput(
      String(Math.round(safeLots * contractSize))
    );
  };

  // =====================================================
  // UNITS
  // =====================================================

  
  const handleUnitsChange = (value) => {
    if (!/^\d*$/.test(value)) return;
  
    setUnitsInput(value);
  
    if (value === "") return;
  
    const parsed = Number(value);
    if (!Number.isFinite(parsed)) return;
  
    const newLots = Math.max(0, parsed / contractSize);
  
    setLots(newLots);
    setLotsInput(newLots.toFixed(4));
  
    const required = calculateMarginForLots(newLots);
  
    setAmountInput(
      required != null ? required.toFixed(2) : ""
    );
  };
  
  // =====================================================
  // BLURS
  // =====================================================

  
  const handleAmountBlur = () => {
    const parsed = Number(amountInput);
  
    if (
      amountInput === "" ||
      amountInput === "." ||
      !Number.isFinite(parsed)
    ) {
      const required = calculateMarginForLots(lots);
  
      setAmountInput(
        required != null ? required.toFixed(2) : ""
      );
  
      return;
    }
  
    setAmountInput(parsed.toFixed(2));
  };

const handleLotsBlur = () => {
const parsed = Number(lotsInput);

if (
  lotsInput === "" ||
  lotsInput === "." ||
  !Number.isFinite(parsed)
) {
  setLotsInput(Number(lots).toFixed(2));
  return;
}

setLotsInput(parsed.toFixed(2));
};

const handleUnitsBlur = () => {
const parsed = Number(unitsInput);

if (
  unitsInput === "" ||
  !Number.isFinite(parsed)
) {
  setUnitsInput(String(units));
  return;
}

setUnitsInput(
  String(Math.round(parsed))
);
};

  // =====================================================
  // SYNC SIZE
  // =====================================================

  const syncInputsFromLots = (newLots) => {
    const safeLots = Math.max(0, Number(newLots) || 0);
  
    setLots(safeLots);
    setLotsInput(safeLots.toFixed(2));
  
    const required = calculateMarginForLots(safeLots);
  
    setAmountInput(
      required != null ? required.toFixed(2) : ""
    );
  
    setUnitsInput(
      String(Math.round(safeLots * contractSize))
    );
  };

const increaseLots = () => {
const newLots = Number(
  (
    Number(lots || 0) + 0.01
  ).toFixed(2)
);

syncInputsFromLots(newLots);
};

const decreaseLots = () => {
const newLots = Math.max(
  0.01,
  Number(
    (
      Number(lots || 0) - 0.01
    ).toFixed(2)
  )
);

syncInputsFromLots(newLots);
};
const changeSizeMode = (mode) => {
  const safeLots = Number(lots) || 0;
  const required = calculateMarginForLots(safeLots);

  setAmountInput(
    required != null ? required.toFixed(2) : ""
  );

  setLotsInput(safeLots.toFixed(2));

  setUnitsInput(
    String(Math.round(safeLots * contractSize))
  );

  setSizeMode(mode);
};

  // =====================================================
  // PRICE FUNCTIONS
  // =====================================================

  const priceStep =
    0.00001;

  const handlePriceChange = (
    value,
    setter
  ) => {
    if (
      !isValidDecimalText(
        value
      )
    ) {
      return;
    }

    setter(value);
  };

  const increasePrice = (
    value,
    setter
  ) => {
    const current =
      Number(value);

    const safeCurrent =
      Number.isFinite(
        current
      )
        ? current
        : currentPrice;

    setter(
      (
        safeCurrent +
        priceStep
      ).toFixed(5)
    );
  };

  const decreasePrice = (
    value,
    setter
  ) => {
    const current =
      Number(value);

    const safeCurrent =
      Number.isFinite(
        current
      )
        ? current
        : currentPrice;

    setter(
      Math.max(
        priceStep,
        safeCurrent -
          priceStep
      ).toFixed(5)
    );
  };

  const handlePriceBlur = (
    value,
    setter
  ) => {
    const parsed =
      Number(value);

    if (
      !Number.isFinite(
        parsed
      ) ||
      parsed <= 0
    ) {
      if (
        currentPrice > 0
      ) {
        setter(
          currentPrice.toFixed(
            5
          )
        );
      }

      return;
    }

    setter(
      parsed.toFixed(5)
    );
  };

  // =====================================================
  // PENDING
  // =====================================================

  const togglePending =
    () => {
      setPendingEnabled(
        (current) => {
          const next =
            !current;

          if (
            next &&
            currentPrice > 0
          ) {
            setPendingPrice(
              currentPrice.toFixed(
                5
              )
            );
          }

          if (!next) {
            setExpiryEnabled(
              false
            );

            setExpiryDate("");
            setExpiryTime("");
          }

          return next;
        }
      );
    };

  // =====================================================
  // STOP LOSS
  // =====================================================

  const toggleStopLoss =
    () => {
      setStopLossEnabled(
        (current) => {
          const next =
            !current;

          if (
            next &&
            currentPrice > 0
          ) {
            setStopLoss(
              currentPrice.toFixed(
                5
              )
            );
          }

          return next;
        }
      );
    };

  // =====================================================
  // TAKE PROFIT
  // =====================================================

  const toggleTakeProfit =
    () => {
      setTakeProfitEnabled(
        (current) => {
          const next =
            !current;

          if (
            next &&
            currentPrice > 0
          ) {
            setTakeProfit(
              currentPrice.toFixed(
                5
              )
            );
          }

          return next;
        }
      );
    };

  // =====================================================
  // EXPIRY
  // =====================================================

  const getTodayDate = () => {
    const now =
      new Date();

    const year =
      now.getFullYear();

    const month =
      String(
        now.getMonth() + 1
      ).padStart(
        2,
        "0"
      );

    const day =
      String(
        now.getDate()
      ).padStart(
        2,
        "0"
      );

    return `${year}-${month}-${day}`;
  };

  const openExpiryDatePicker =
    () => {
      const input =
        dateInputRef.current;

      if (!input) {
        return;
      }

      try {
        if (
          typeof input.showPicker ===
          "function"
        ) {
          input.showPicker();
        } else {
          input.click();
        }
      } catch {
        input.click();
      }
    };

    const openExpiryTimePicker = () => {
      const input = timeInputRef.current;
    
      if (!input) return;
    
      try {
        input.focus();
    
        if (typeof input.showPicker === "function") {
          input.showPicker();
        } else {
          input.click();
        }
      } catch (err) {
        input.click();
      }
    };

    const handleExpiryDateChange = (e) => {
      const value = e.target.value;
    
      setExpiryDate(value);
    
      if (value) {
        setTimeout(() => {
          openExpiryTimePicker();
        }, 100);
      }
    };

    const handleExpiryTimeChange = (e) => {
      const value = e.target.value;
    
      setExpiryTime(value);
    
      if (expiryDate && value) {
        setExpiryEnabled(true);
      }
    };

  const removeExpiry =
    () => {
      setExpiryEnabled(
        false
      );

      setExpiryDate("");
      setExpiryTime("");
    };

  const formatExpiryDate = (
    dateString
  ) => {
    if (!dateString) {
      return "";
    }

    const [
      year,
      month,
      day,
    ] =
      dateString.split("-");

    const date =
      new Date(
        Number(year),
        Number(month) - 1,
        Number(day)
      );

    return date.toLocaleDateString(
      "en-GB",
      {
        month: "short",
        day: "numeric",
        year: "numeric",
      }
    );
  };

  const formatExpiryTime = (
    timeString
  ) => {
    if (!timeString) {
      return "";
    }

    const [
      hours,
      minutes,
    ] =
      timeString.split(":");

    const date =
      new Date();

    date.setHours(
      Number(hours),
      Number(minutes),
      0,
      0
    );

    return date.toLocaleTimeString(
      "en-GB",
      {
        hour: "2-digit",
        minute: "2-digit",
      }
    );
  };

  const expiryValid =
    useMemo(() => {
      if (!expiryEnabled) {
        return true;
      }

      if (
        !expiryDate ||
        !expiryTime
      ) {
        return false;
      }

      const expiry =
        new Date(
          `${expiryDate}T${expiryTime}`
        );

      if (
        Number.isNaN(
          expiry.getTime()
        )
      ) {
        return false;
      }

      return (
        expiry.getTime() >
        Date.now()
      );
    }, [
      expiryEnabled,
      expiryDate,
      expiryTime,
    ]);

  // =====================================================
  // PENDING ORDER TYPE
  // =====================================================

  const pendingOrderType =
    useMemo(() => {
      if (
        !pendingEnabled
      ) {
        return "Market";
      }

      const entry =
        Number(
          pendingPrice
        );

      if (
        !Number.isFinite(
          entry
        )
      ) {
        return "Limit";
      }

      if (isBuy) {
        return entry >
          currentPrice
          ? "Stop"
          : "Limit";
      }

      return entry <
        currentPrice
        ? "Stop"
        : "Limit";
    }, [
      pendingEnabled,
      pendingPrice,
      currentPrice,
      isBuy,
    ]);

  // =====================================================
  // TAKE PROFIT AMOUNT
  // =====================================================

  const takeProfitAmount =
    useMemo(() => {
      const tp =
        Number(
          takeProfit
        );

      if (
        !takeProfitEnabled ||
        currentPrice <= 0 ||
        !Number.isFinite(
          tp
        ) ||
        tp <= 0
      ) {
        return 0;
      }

      const difference =
        isBuy
          ? tp -
            currentPrice
          : currentPrice -
            tp;

      return Math.max(
        0,
        difference *
          units
      );
    }, [
      takeProfitEnabled,
      takeProfit,
      currentPrice,
      units,
      isBuy,
    ]);

  // =====================================================
  // STOP LOSS AMOUNT
  // =====================================================

  const stopLossAmount =
    useMemo(() => {
      const sl =
        Number(
          stopLoss
        );

      if (
        !stopLossEnabled ||
        currentPrice <= 0 ||
        !Number.isFinite(
          sl
        ) ||
        sl <= 0
      ) {
        return 0;
      }

      const difference =
        isBuy
          ? currentPrice -
            sl
          : sl -
            currentPrice;

      return Math.max(
        0,
        difference *
          units
      );
    }, [
      stopLossEnabled,
      stopLoss,
      currentPrice,
      units,
      isBuy,
    ]);

  // =====================================================
  // VALIDATION
  // =====================================================

  const pendingValid =
    !pendingEnabled ||
    Number(
      pendingPrice
    ) > 0;

  const slValid =
    !stopLossEnabled ||
    Number(
      stopLoss
    ) > 0;

  const tpValid =
    !takeProfitEnabled ||
    Number(
      takeProfit
    ) > 0;

 







const hasEnoughMargin =
marginCalculationValid &&
Number.isFinite(marginAvailable) &&
marginAvailable >= marginRequired;

const canPlaceOrder =
Number(lots) > 0 &&
currentPrice > 0 &&
!balanceLoading &&
!balanceError &&
marginCalculationValid &&
hasEnoughMargin &&
pendingValid &&
slValid &&
tpValid &&
expiryValid &&
orderStatus !== "processing";

  // =====================================================
  // BUTTON TEXT
  // =====================================================

  const orderButtonText =
    pendingEnabled
      ? `${
          isBuy
            ? "Buy"
            : "Sell"
        } ${pendingOrderType} Order at ${Number(
          pendingPrice || 0
        ).toFixed(5)}`
      : `${
          isBuy
            ? "Buy"
            : "Sell"
        } at ${Number(
          currentPrice
        ).toFixed(5)}`;

  // =====================================================
  // PLACE ORDER
  // =====================================================


  
const handlePlaceOrder = async () => {
  // Zuia kubonyeza mara nyingi wakati order inashughulikiwa
  if (orderStatus === "processing") return;

  // Kagua inputs kabla ya kuendelea
  if (!canPlaceOrder || !marginCalculationValid) {
    setOrderError(
      "Unable to place order. Please check the lot size, price and margin."
    );
    setOrderStatus("error");
    return;
  }

  try {
    setOrderStatus("processing");
    setOrderError("");
    setPlacedOrder(null);

    // 1. Pata username
    const storedUsername = localStorage.getItem("username");
    const username = storedUsername?.trim();

    if (!username) {
      throw new Error("Username not found. Please sign in again.");
    }

    // 2. Soma akaunti ya mtumiaji
    const usersQuery = query(
      collection(db, "users"),
      where("username", "==", username),
      limit(1)
    );

    const usersSnapshot = await getDocs(usersQuery);

    if (usersSnapshot.empty) {
      throw new Error("User account was not found.");
    }

    const userDoc = usersSnapshot.docs[0];
    const userData = userDoc.data();

    const balance = Number(userData.usdtBalanceOther);

    if (!Number.isFinite(balance) || balance < 0) {
      throw new Error("Account balance is invalid.");
    }

    // 3. Soma orders zote za mtumiaji
    const ordersQuery = query(
      collection(db, "Forex"),
      where("username", "==", username)
    );

    const ordersSnapshot = await getDocs(ordersQuery);

    // 4. Jumlisha margin ya orders ambazo bado ziko wazi/pending
    const usedMargin = ordersSnapshot.docs.reduce(
      (total, orderDoc) => {
        const order = orderDoc.data();
        const status = String(order.status || "").toLowerCase();

        const isClosed =
          order.closed === true ||
          status === "closed" ||
          status === "cancelled" ||
          status === "canceled" ||
          status === "rejected" ||
          status === "expired";

        if (isClosed) return total;

        const isActive =
          status === "open" ||
          status === "pending" ||
          order.isPending === true;

        if (!isActive) return total;

        const orderMargin = Number(
          order.marginRequired ?? order.margin ?? 0
        );

        if (!Number.isFinite(orderMargin) || orderMargin < 0) {
          throw new Error(
            "An existing order has invalid margin data. Please review it before placing another order."
          );
        }

        return total + orderMargin;
      },
      0
    );

    // 5. Kokotoa margin inayobaki
    const freeMargin = Math.max(0, balance - usedMargin);
    const requiredMargin = Number(marginRequired);

    if (!Number.isFinite(requiredMargin) || requiredMargin <= 0) {
      throw new Error("Required margin is invalid.");
    }

    // 6. Alert ikiwa margin haitoshi
    if (requiredMargin > freeMargin + 0.000001) {
      setOrderError(
        "Not enough funds available.\nPlease fund your account."
      );
      setOrderStatus("error");
      return;
    }

    // 7. Kagua entry price
    const finalEntryPrice = pendingEnabled
      ? Number(pendingPrice)
      : Number(currentPrice);

    if (
      !Number.isFinite(finalEntryPrice) ||
      finalEntryPrice <= 0
    ) {
      throw new Error("Invalid entry price.");
    }

    // 8. Weka aina na status ya order
    const finalOrderType = pendingEnabled
      ? String(pendingOrderType).toLowerCase()
      : "market";

    const forexStatus = pendingEnabled ? "pending" : "open";

    // 9. Tengeneza order document
    const forexOrder = {
      username,

      symbol: cleanSymbol,
      displaySymbol: String(symbol),
      baseCurrency,
      quoteCurrency,
      market: "Forex",

      side: isBuy ? "buy" : "sell",
      action: isBuy ? "Bought" : "Sold",

      type: finalOrderType,
      status: forexStatus,
      isPending: pendingEnabled,
      closed: false,

      marketPrice: Number(currentPrice),
      entryPrice: finalEntryPrice,
      openPrice: pendingEnabled ? null : finalEntryPrice,
      currentPrice: Number(currentPrice),

      lots: Number(Number(lots).toFixed(4)),
      units: Number(units),
      amount: Number(Number(amount).toFixed(2)),

      // Margin inayohitajika kwa order hii
      marginRequired: Number(requiredMargin.toFixed(2)),

      // Taarifa za margin wakati order inafunguliwa
      usedMarginAtOpen: Number(usedMargin.toFixed(2)),
      freeMarginAtOpen: Number(freeMargin.toFixed(2)),
      balanceAtOpen: Number(balance.toFixed(2)),
      marginAvailableAtOpen: Number(freeMargin.toFixed(2)),

      stopLossEnabled,
      stopLoss: stopLossEnabled ? Number(stopLoss) : null,
      stopLossAmount: stopLossEnabled
        ? Number(Number(stopLossAmount).toFixed(2))
        : null,

      takeProfitEnabled,
      takeProfit: takeProfitEnabled ? Number(takeProfit) : null,
      takeProfitAmount: takeProfitEnabled
        ? Number(Number(takeProfitAmount).toFixed(2))
        : null,

      expiryEnabled: pendingEnabled && expiryEnabled,

      expiry:
        pendingEnabled && expiryEnabled && expiryDate && expiryTime
          ? `${expiryDate}T${expiryTime}`
          : null,

      expiryDate:
        pendingEnabled && expiryEnabled ? expiryDate : null,

      expiryTime:
        pendingEnabled && expiryEnabled ? expiryTime : null,

      profitLoss: 0,
      realisedProfitLoss: 0,

      closePrice: null,
      closedAt: null,

      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    };

    // 10. Hifadhi order baada ya ukaguzi
    const docRef = await addDoc(
      collection(db, "Forex"),
      forexOrder
    );

    // 11. Onyesha mafanikio
    setPlacedOrder({
      ...forexOrder,
      id: docRef.id,
      entryPrice: finalEntryPrice,
    });

    setOrderStatus("success");

    console.log("FOREX ORDER SAVED:", docRef.id);
  } catch (error) {
    console.error("Failed to place Forex order:", error);

    setOrderError(
      error?.message ||
        "Unable to place order. Please try again."
    );

    setOrderStatus("error");
  }
};


  // =====================================================
  // RETURN
  // =====================================================

  return (
    <div className="confirm-order-page">
<ForexHeader/>
<ForexBottomNav/>

      {/* =================================================
          HEADER
      ================================================= */}

      <header className="order-header">

        <button
          type="button"
          className="order-back"
          onClick={() =>
            navigate(-1)
          }
          aria-label="Go back"
        >
          ‹
        </button>

        <div className="order-symbol">

          <h1>
            {symbol}
          </h1>

          <span>
            Forex
          </span>

        </div>

        <button
          type="button"
          className="order-menu"
          aria-label="More options"
        >
          ⋮
        </button>

      </header>

      {/* =================================================
          BUY / SELL
      ================================================= */}

      <div className="order-quotes">

        <div
          className={
            !isBuy
              ? "quote sell selected"
              : "quote sell"
          }
        >
          <span>
            Sell
          </span>

          <strong>
            {currentPrice > 0
              ? currentPrice.toFixed(
                  5
                )
              : "--"}
          </strong>
        </div>

        <div
          className={
            isBuy
              ? "quote buy selected"
              : "quote buy"
          }
        >
          <span>
            Buy
          </span>

          <strong>
            {currentPrice > 0
              ? currentPrice.toFixed(
                  5
                )
              : "--"}
          </strong>
        </div>

      </div>

      {/* =================================================
          SIZE
      ================================================= */}

      <section className="order-card size-card">

        <div className="size-tabs">

          <button
            type="button"
            className={
              sizeMode ===
              "amount"
                ? "active"
                : ""
            }
            onClick={() =>
              changeSizeMode(
                "amount"
              )
            }
          >
            Amount
          </button>

          <button
            type="button"
            className={
              sizeMode ===
              "lots"
                ? "active"
                : ""
            }
            onClick={() =>
              changeSizeMode(
                "lots"
              )
            }
          >
            Lots
          </button>

          <button
            type="button"
            className={
              sizeMode ===
              "units"
                ? "active"
                : ""
            }
            onClick={() =>
              changeSizeMode(
                "units"
              )
            }
          >
            Units
          </button>

        </div>

        {/* SIZE INPUT */}

        <div className="size-input">

          <div className="editable-size-value">

            {sizeMode ===
              "amount" && (
              <>
                <span className="size-prefix">
                  $
                </span>

                <input
                  type="text"
                  inputMode="decimal"
                  value={
                    amountInput
                  }
                  onChange={(e) =>
                    handleAmountChange(
                      e.target.value
                    )
                  }
                  onFocus={(e) =>
                    e.target.select()
                  }
                  onBlur={
                    handleAmountBlur
                  }
                  placeholder="0.00"
                  autoComplete="off"
                />
              </>
            )}

            {sizeMode ===
              "lots" && (
              <input
                type="text"
                inputMode="decimal"
                value={
                  lotsInput
                }
                onChange={(e) =>
                  handleLotsChange(
                    e.target.value
                  )
                }
                onFocus={(e) =>
                  e.target.select()
                }
                onBlur={
                  handleLotsBlur
                }
                placeholder="0.01"
                autoComplete="off"
              />
            )}

            {sizeMode ===
              "units" && (
              <>
                <span className="currency-badge">
                  {baseCurrency}
                </span>

                <input
                  type="text"
                  inputMode="numeric"
                  value={
                    unitsInput
                  }
                  onChange={(e) =>
                    handleUnitsChange(
                      e.target.value
                    )
                  }
                  onFocus={(e) =>
                    e.target.select()
                  }
                  onBlur={
                    handleUnitsBlur
                  }
                  placeholder="0"
                  autoComplete="off"
                />
              </>
            )}

          </div>

          <div className="step-buttons">

            <button
              type="button"
              onClick={
                decreaseLots
              }
            >
              −
            </button>

            <button
              type="button"
              onClick={
                increaseLots
              }
            >
              +
            </button>

          </div>

        </div>

        {/* SIZE SUMMARY */}

        <div className="size-summary">

          {sizeMode ===
          "amount" ? (
            <>
              <span>
                Lots:{" "}
                {Number(
                  lots
                ).toFixed(2)}
              </span>

              <span>
                Units:{" "}
                {units.toLocaleString(
                  "en-GB"
                )}{" "}
                {baseCurrency}
              </span>
            </>
          ) : sizeMode ===
            "lots" ? (
            <>
              <span>
                Amount: $
                {amount.toFixed(
                  2
                )}
              </span>

              <span>
                Units:{" "}
                {units.toLocaleString(
                  "en-GB"
                )}{" "}
                {baseCurrency}
              </span>
            </>
          ) : (
            <>
              <span>
                Amount: $
                {amount.toFixed(
                  2
                )}
              </span>

              <span>
                Lots:{" "}
                {Number(
                  lots
                ).toFixed(2)}
              </span>
            </>
          )}

        </div>

        {/* =================================================
            PENDING SWITCH
        ================================================= */}

        <div className="order-option">

          <span>
            {isBuy
              ? "Buy"
              : "Sell"}{" "}
            when price is
          </span>

          <button
            type="button"
            className={
              pendingEnabled
                ? "switch on"
                : "switch"
            }
            onClick={
              togglePending
            }
          >
            <span />
          </button>

        </div>

        {/* =================================================
            PENDING CONTENT
        ================================================= */}

        {pendingEnabled && (
          <>

            <div className="rate-input">

              <input
                className="manual-rate-input"
                type="text"
                inputMode="decimal"
                value={
                  pendingPrice
                }
                onChange={(e) =>
                  handlePriceChange(
                    e.target.value,
                    setPendingPrice
                  )
                }
                onFocus={(e) =>
                  e.target.select()
                }
                onBlur={() =>
                  handlePriceBlur(
                    pendingPrice,
                    setPendingPrice
                  )
                }
              />

              <div className="step-buttons">

                <button
                  type="button"
                  onClick={() =>
                    decreasePrice(
                      pendingPrice,
                      setPendingPrice
                    )
                  }
                >
                  −
                </button>

                <button
                  type="button"
                  onClick={() =>
                    increasePrice(
                      pendingPrice,
                      setPendingPrice
                    )
                  }
                >
                  +
                </button>

              </div>

            </div>

            <div className="pending-type-info">
              {isBuy
                ? "Buy"
                : "Sell"}{" "}
              {pendingOrderType}
            </div>






   
            {!expiryDate && (
<input
  ref={dateInputRef}
  type="date"
  className="native-expiry-picker"
  value={expiryDate}
  min={getTodayDate()}
  onChange={handleExpiryDateChange}
/>
)}

{expiryDate && !expiryTime && (
<input
  ref={timeInputRef}
  type="time"
  className="native-expiry-picker"
  value={expiryTime}
  onChange={handleExpiryTimeChange}
/>
)}


            {/* NATIVE DATE */}

            {!expiryDate ? (
<button
  type="button"
  className="expiry-button"
  onClick={openExpiryDatePicker}
>
  <span className="expiry-plus">+</span>
  Add date of expiry
</button>
) : (
<div className="expiry-selected">

  <div className="expiry-controls">

    <button
      type="button"
      className="expiry-value-button"
      onClick={openExpiryDatePicker}
    >
      {formatExpiryDate(expiryDate)}
    </button>

    <button
      type="button"
      className="expiry-value-button"
      onClick={openExpiryTimePicker}
    >
      {expiryTime
        ? formatExpiryTime(expiryTime)
        : "Select time"}
    </button>

    <button
      type="button"
      className="expiry-remove"
      onClick={removeExpiry}
    >
      ×
    </button>

  </div>

  {!expiryValid && (
    <div className="expiry-error">
      Expiry date and time must be in the future.
    </div>
  )}

</div>
)}
          </>
        )}


        {/* =================================================
            MARGIN
        ================================================= */}

        <div className="margin-row">

          <div>
            <small>
              MARGIN REQUIRED
            </small>

           
            <strong>
{Number.isFinite(marginRequired)
  ? `USDT ${marginRequired.toFixed(2)}`
  : "Margin haipatikani"}
</strong>

          </div>

          <div>
            <small>
              MARGIN AVAILABLE
            </small>

          
            <strong>
  {balanceLoading
    ? "Loading..."
    : balanceError
      ? "--"
      : `$ ${Number(marginAvailable).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`}
</strong>

          </div>

        </div>

        {!balanceLoading &&
          !balanceError &&
          !hasEnoughMargin && (
            <div className="margin-error">
              Insufficient balance
            </div>
          )}

        {!balanceLoading &&
          balanceError && (
            <div className="margin-error">
              {balanceError}
            </div>
          )}

      </section>

      {/* =================================================
          STOP LOSS
      ================================================= */}

      <section className="order-card protection-card">

        <div className="protection-header">

          <span>
            Stop loss:
          </span>

          <button
            type="button"
            className={
              stopLossEnabled
                ? "switch on"
                : "switch"
            }
            onClick={
              toggleStopLoss
            }
          >
            <span />
          </button>

        </div>

        {stopLossEnabled && (
          <div className="protection-content">

            <div className="protection-tabs">
              <strong>
                Rate
              </strong>

              <span>
                Loss Amount
              </span>
            </div>

            <div className="protection-value">

              <div className="rate-input">

                <input
                  className="manual-rate-input"
                  type="text"
                  inputMode="decimal"
                  value={
                    stopLoss
                  }
                  onChange={(e) =>
                    handlePriceChange(
                      e.target.value,
                      setStopLoss
                    )
                  }
                  onFocus={(e) =>
                    e.target.select()
                  }
                  onBlur={() =>
                    handlePriceBlur(
                      stopLoss,
                      setStopLoss
                    )
                  }
                />

                <div className="step-buttons">

                  <button
                    type="button"
                    onClick={() =>
                      decreasePrice(
                        stopLoss,
                        setStopLoss
                      )
                    }
                  >
                    −
                  </button>

                  <button
                    type="button"
                    onClick={() =>
                      increasePrice(
                        stopLoss,
                        setStopLoss
                      )
                    }
                  >
                    +
                  </button>

                </div>

              </div>

              <strong className="loss-value">
                {stopLossAmount >
                0
                  ? `-$${stopLossAmount.toFixed(
                      2
                    )}`
                  : "-"}
              </strong>

            </div>

          </div>
        )}

      </section>

      {/* =================================================
          TAKE PROFIT
      ================================================= */}

      <section className="order-card protection-card">

        <div className="protection-header">

          <span>
            Take profit:
          </span>

          <button
            type="button"
            className={
              takeProfitEnabled
                ? "switch on"
                : "switch"
            }
            onClick={
              toggleTakeProfit
            }
          >
            <span />
          </button>

        </div>

        {takeProfitEnabled && (
          <div className="protection-content">

            <div className="protection-tabs">

              <strong>
                Rate
              </strong>

              <span>
                Profit Amount
              </span>

            </div>

            <div className="protection-value">

              <div className="rate-input">

                <input
                  className="manual-rate-input"
                  type="text"
                  inputMode="decimal"
                  value={
                    takeProfit
                  }
                  onChange={(e) =>
                    handlePriceChange(
                      e.target.value,
                      setTakeProfit
                    )
                  }
                  onFocus={(e) =>
                    e.target.select()
                  }
                  onBlur={() =>
                    handlePriceBlur(
                      takeProfit,
                      setTakeProfit
                    )
                  }
                />

                <div className="step-buttons">

                  <button
                    type="button"
                    onClick={() =>
                      decreasePrice(
                        takeProfit,
                        setTakeProfit
                      )
                    }
                  >
                    −
                  </button>

                  <button
                    type="button"
                    onClick={() =>
                      increasePrice(
                        takeProfit,
                        setTakeProfit
                      )
                    }
                  >
                    +
                  </button>

                </div>

              </div>

              <strong className="profit-value">
                {takeProfitAmount >
                0
                  ? `$${takeProfitAmount.toFixed(
                      2
                    )}`
                  : "-"}
              </strong>

            </div>

          </div>
        )}

      </section>

      {/* =================================================
          PLACE ORDER BUTTON
      ================================================= */}

      <div className="place-order-wrapper">

        <button
          type="button"
          disabled={
            !canPlaceOrder
          }
          className={
            isBuy
              ? "place-order buy"
              : "place-order sell"
          }
          onClick={
            handlePlaceOrder
          }
        >
          {orderButtonText}
        </button>

      </div>

      {/* =================================================
          PROCESSING / RESULT OVERLAY
      ================================================= */}

      {orderStatus !==
        "idle" && (
        <div className="order-result-overlay">

          <div className="order-result-sheet">

            {/* ===============================
                PROCESSING
            =============================== */}

            {orderStatus ===
              "processing" && (
              <div className="order-processing">

                <div className="processing-spinner" />

                <h2>
                  Processing...
                </h2>

                <p>
                  Please wait
                </p>

              </div>
            )}

            {/* ===============================
                SUCCESS
            =============================== */}

            {orderStatus ===
              "success" &&
              placedOrder && (
              <div className="order-success">

                <div className="success-check">
                  ✓
                </div>

                <h2>
                  {placedOrder.symbol}
                </h2>

                <p>
                  {placedOrder.side ===
                  "buy"
                    ? "Bought"
                    : "Sold"}{" "}
                  {Number(
                    placedOrder.lots
                  ).toFixed(2)}{" "}
                  lots at{" "}
                  {Number(
                    placedOrder.entryPrice
                  ).toFixed(5)}.
                </p>

                <button
                  type="button"
                  className="order-result-ok"
                  onClick={() => {
                    setOrderStatus(
                      "idle"
                    );

                    setPlacedOrder(
                      null
                    );

                    navigate(-1);
                  }}
                >
                  OK
                </button>

              </div>
            )}

            {/* ===============================
                ERROR
            =============================== */}

            {orderStatus ===
              "error" && (
              <div className="order-failed">

                <div className="error-cross">
                  ×
                </div>

                <h2>
                  Order Failed
                </h2>

                <p>
                  {orderError}
                </p>

                <button
                  type="button"
                  className="order-result-ok"
                  onClick={() => {
                    setOrderStatus(
                      "idle"
                    );

                    setOrderError(
                      ""
                    );
                  }}
                >
                  OK
                </button>

              </div>
            )}

          </div>

        </div>
      )}

    </div>
  );
};

export default ConfirmOrder;